import { bindService, type AppFeatureDefinition } from "@nasam/kernel";
import {
  companiesRepositoryToken,
  devicesRepositoryToken,
  gprsCommandsRepositoryToken,
  type CompaniesRepository,
  type DevicesRepository,
} from "../../contracts";
import { createGprsCommandsHttpRepository } from "./data";
import { createGprsRoutes } from "./presentation/routes";
import { GPRS_VIEW } from "./gprsPermissions";

export * from "./gprsPermissions";

// `/devices/gprs-commands`: the catalog, send, list and one command. The
// token is a shared contract (Tracking opens the Send form too).
export { gprsCommandsRepositoryToken };

export const gprsFeature: AppFeatureDefinition = {
  id: "gprs",
  version: "0.1.0",
  titleKey: "gprs:moduleTitle",
  icon: "Command",
  basePath: "/gprs",
  requiredPermissions: [GPRS_VIEW],
  // Every CORE feature shares one "core" rail node (see mergeFeatureNavNodes);
  // this feature contributes the "GPRS" leaf under it.
  navigation: [
    {
      id: "core",
      titleKey: "common:businessModules.core",
      icon: "Layers",
      placement: "rail",
      order: 10,
      children: [
        {
          id: "gprs",
          titleKey: "gprs:moduleTitle",
          icon: "Command",
          placement: "drawer",
          order: 70,
          path: "/gprs",
          requiredPermissions: [GPRS_VIEW],
        },
      ],
    },
  ],
  routes: (context) =>
    createGprsRoutes({
      context,
      gprsCommands: context.services.resolve(gprsCommandsRepositoryToken),
      companies: context.services.tryResolve<CompaniesRepository>(
        companiesRepositoryToken,
      ),
      devices: context.services.tryResolve<DevicesRepository>(
        devicesRepositoryToken,
      ),
    }),
  provideServices: ({ httpClient }) => [
    bindService(gprsCommandsRepositoryToken, createGprsCommandsHttpRepository(httpClient)),
  ],
  permissionCatalog: [
    {
      segment: "core",
      labelKey: "gprs:permissions.core",
      children: [
        {
          segment: "gprs_management",
          labelKey: "gprs:permissions.gprsManagement",
          children: [
            {
              segment: "gprs_management_list",
              labelKey: "gprs:permissions.gprs",
              actions: [
                { id: "create", labelKey: "gprs:actions.create" },
                { id: "view", labelKey: "gprs:actions.view" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
